/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useCityContext } from "../../../../context/levels/levelsContext";
import { useCompanyContext } from "../../../../context/company/companyContext";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { useAdminsContext } from "../../../../context/admin/context/AdminManageContext";
import { useCountryContext } from "../../../../context/country/countryContext/CountryContext";
import {
  Title,
  GoBack,
  MyMessage,
  InputField,
  PhoneInput,
  SelectInput,
  PasswordField,
  MyActionButton,
  SearchSelectInput,
} from "../../component/Component";
import { roles } from "./roles";
import { pushCountry } from "../../../../middlewares";
import { countriesList } from "../../component/data";

const Add = () => {
  const { sysAdmin } = useAdminContext();
  const { create, setAdmins } = useAdminsContext();
  const currentRole = sysAdmin?.role;

  const { cities, fetchCities } = useCityContext();
  const { company, setCompany } = useCompanyContext();
  const { countries, fetchCountries } = useCountryContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [first_name, setFirstName] = useState(null);
  const [last_name, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [password, setPassword] = useState(null);
  const [country, setCountry] = useState("Uganda");
  const [city, setCity] = useState(company ? company?.city : null);
  const [role, setRole] = useState("Content Creator");
  const [address, setAddress] = useState(null);

  const adminRoutes = "/admin";

  useEffect(() => {
    if (!cities) fetchCities(1, 2000);
    if (!countries) fetchCountries();
  }, [cities, countries, country]);

  const cleanFields = () => {
    setLoading(false);
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPhone(null);
    setPassword(null);
    setAddress(null);
  };

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const addOneTourPackageHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!first_name || first_name === "") return responses(true, "first name is required");
    if (!last_name || last_name === "") return responses(true, "last name is required");
    if (!email || email === "") return responses(true, "email is required");
    if (!country || country === "") return responses(true, "country is required");
    if (!phone || phone === "") return responses(true, "phone number is required");
    if (!city || city === "") return responses(true, "city is required");
    if (!address || address === "") return responses(true, "address is required");
    if (!role || role === "") return responses(true, "role is required");
    if (!password || password === "") return responses(true, "password is required");

    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      email,
      first_name,
      last_name,
      phonenumber: phone,
      password,
      country,
      city,
      address,
      company_id: sysAdmin?.company_id,
      role: String(role)?.toLowerCase()?.replaceAll(" ", "_"),
    };

    const { message, status } = await create(data);
    if (status === 200 || status === 201) {
      cleanFields();
      setAdmins(null);
      setCompany(null);
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const citiesFilter = () => {
    const getId = ({ data, key, value, obj_id }) =>
      data?.find((x) => x?.[key] === value)?.[obj_id] || null;
    const id = getId({
      key: "name",
      value: country,
      data: countries,
      obj_id: "country_id",
    });
    return cities?.filter((x) => x?.country_id === id).map((y) => y?.name);
  };

  return (
    <div className="min-h-full bg-gray-50/70 p-4 overflow-y-auto">
      <div className="mx-auto w-full max-w-5xl pb-20">
        <GoBack props={{ route: adminRoutes }} />

        <form onSubmit={addOneTourPackageHandler} className="mt-4 space-y-6">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="h-1.5 rounded-t-2xl bg-gradient-to-r from-emerald-500 via-amber-500 to-fuchsia-500" />
            <div className="p-5">
              <div className="mb-2">
                <Title props={{ title: "Create New Admin" }} />
                <p className="mt-1 text-xs text-gray-600">
                  Add a new team member with the correct role and location details.
                </p>
              </div>

              {/* Sections */}
              <div className="grid grid-cols-1 gap-5">
                {/* Identity */}
                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Identity
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Basic details used across the dashboard.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <InputField
                      props={{
                        id: "first_name",
                        title: "First Name",
                        type: "text",
                        required: true,
                        value: first_name || "",
                        onChange: (e) => {
                          setFirstName(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <InputField
                      props={{
                        id: "last_name",
                        title: "Last Name",
                        type: "text",
                        required: true,
                        value: last_name || "",
                        onChange: (e) => {
                          setLastName(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                    <InputField
                      props={{
                        id: "email",
                        title: "Email Address",
                        type: "email",
                        required: true,
                        value: email || "",
                        onChange: (e) => {
                          setEmail(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                  </div>
                </section>

                {/* Contact & Password */}
                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Contact & Security
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Phone number and sign-in credentials.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <div className="w-full">
                      <PhoneInput
                        phone={phone}
                        required={true}
                        setPhone={setPhone}
                        country={country || ""}
                      />
                    </div>
                    <PasswordField
                      value={password || ""}
                      required={true}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError(null);
                        setSuccess(null);
                      }}
                    />
                  </div>
                </section>

                {/* Location */}
                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Location
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Country and city for localized permissions and content.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <SelectInput
                      title="Country"
                      defaultValue={country || null}
                      required={true}
                      value={country || null}
                      options={countries ? countries?.map((x) => x?.name) : []}
                      onChange={(e) => {
                        setCountry(e.target.value);
                        setCity(null);
                        const pickedCountry = countriesList?.find(
                          (_c) =>
                            String(_c.name).toLowerCase() ===
                            String(e.target.value).toLowerCase()
                        );
                        pushCountry({
                          country: {
                            id: pickedCountry?.id,
                            name: pickedCountry?.name,
                            slug: pickedCountry?.name,
                            route: "/admin",
                          },
                        });
                      }}
                    />
                    <SearchSelectInput
                      title="City"
                      setValue={setCity}
                      value={city || null}
                      required={true}
                      options={
                        cities
                          ? country && !city
                            ? citiesFilter()
                            : cities?.map((x) => x?.name)
                          : []
                      }
                      onChange={(value) => setCity(value)}
                    />
                    <InputField
                      props={{
                        id: "address",
                        title: "Address",
                        type: "address",
                        required: true,
                        value: address || "",
                        onChange: (e) => {
                          setAddress(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                  </div>
                </section>

                {/* Access */}
                <section className="rounded-xl border border-gray-100 bg-white p-4">
                  <h3 className="text-sm font-semibold tracking-tight text-gray-900">
                    Access & Role
                  </h3>
                  <p className="mt-0.5 text-xs text-gray-600">
                    Choose the role for the new admin.
                  </p>
                  <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                    <SelectInput
                      title="Admin Role"
                      defaultValue={role}
                      required={true}
                      options={roles(currentRole)}
                      onChange={(e) => {
                        setRole(e.target.value);
                        setError(null);
                        setSuccess(null);
                      }}
                    />
                  </div>
                </section>
              </div>
            </div>

            <div className="border-t border-gray-100 bg-white px-5 py-4 rounded-b-2xl">
              <div className="flex items-center justify-end">
                <MyActionButton
                  loading={loading}
                  title="Add New Admin"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage(null);
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
